module.exports = __webpack_public_path__ + "img/assistance_btn_img.c702430d.png";